export enum EFormErrorType {
  REQUIRED = "required",
  PATTERN = "pattern",
}
